var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('SlideMenu',[_c('Header'),_vm._v(" "),_c('nuxt',{key:_vm.pageKey}),_vm._v(" "),_c('Footer')],1),_vm._v(" "),_c('client-only',[_c('MobileSearch'),_vm._v(" "),_c('AuthModal')],1),_vm._v(" "),_c('ScrollToTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }